import RightLeftLayout from "components/common/RightLeftLayout/RightLeftLayout";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import * as React from "react";
import OrderSummary from "screens/PurchaseComplete/OrderSummary";
import PointsSummary from "screens/PurchaseComplete/PointsSummary";
import { load } from "utils/ConfigLoader";

const PurchaseComplete = () => {
  const purchasedCategoryList = load("purchase.categoryList");
  let purchasedCategoryListDescription = "";
  if (purchasedCategoryList) {
    purchasedCategoryListDescription = purchasedCategoryList
      .map((category: any) => category.name)
      .join(", ");
  }

  return (
    <React.Fragment>
      <RightLeftLayout
        title="Purchase Complete"
        closeButtonHandler
        whiteRightPanel
        leftPanel={
          <OrderSummary
            purchasedCategoryListDescription={purchasedCategoryListDescription}
          />
        }
        rightPanel={
          <CustomerDataContext.Consumer>
            {loggedCustomer => (
              <PointsSummary loggedCustomer={loggedCustomer} />
            )}
          </CustomerDataContext.Consumer>
        }
      />
    </React.Fragment>
  );
};

export default PurchaseComplete;



// WEBPACK FOOTER //
// ./src/screens/PurchaseComplete/index.tsx